import { InputMask } from '@react-input/mask'
import { KTextField, KTextFieldProps } from 'components/core/KTextField'
import { ForwardRefExoticComponent, RefAttributes, forwardRef } from 'react'
import { cardFromNumber } from 'services'

interface KCreditCardCodeFieldProps extends Omit<KTextFieldProps, 'type'> {
  cardNumber: string
}

export const KCreditCardCodeField: ForwardRefExoticComponent<
  Omit<KCreditCardCodeFieldProps, 'ref'> & RefAttributes<HTMLDivElement>
> = forwardRef((props, ref) => {
  const { cardNumber, ...restProps } = props
  const card = cardFromNumber(cardNumber)
  const maxLength = card ? Math.max(...card.cvcLengths) : 3
  const mask = ' '.repeat(maxLength)
  const replacement = { ' ': /\d/ }

  return (
    <KTextField
      ref={ref}
      InputProps={{ inputComponent: InputMask }}
      inputProps={{
        autoComplete: 'one-time-code',
        align: 'center',
        mask,
        replacement,
      }}
      {...restProps}
    />
  )
})
